webpackJsonp([14222560173934893000,14024119220119706000],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",[\"/opt/build/repo/node_modules/babel-plugin-module-alias/lib/index.js\",[{\"src\":\"./src/components\",\"expose\":\"components\"},{\"src\":\"./src/components/base\",\"expose\":\"baseComponents\"},{\"src\":\"./src/components/hybrid\",\"expose\":\"hybridComponents\"},{\"src\":\"./src/config\",\"expose\":\"config\"},{\"src\":\"./src/layouts\",\"expose\":\"layouts\"},{\"src\":\"./src/lib\",\"expose\":\"lib\"},{\"src\":\"./src/pages\",\"expose\":\"pages\"},{\"src\":\"./src/stories\",\"expose\":\"stories\"},{\"src\":\"./src/themes\",\"expose\":\"themes\"},{\"src\":\"./src/media\",\"expose\":\"media\"}]],\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/doctor_moonlighting_jobs_in.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _queryString = __webpack_require__("./node_modules/query-string/index.js");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _pageTitle = __webpack_require__("./src/components/base/pageTitle.js");
	
	var _pageTitle2 = _interopRequireDefault(_pageTitle);
	
	var _mainHelmet = __webpack_require__("./src/components/base/mainHelmet.js");
	
	var _mainHelmet2 = _interopRequireDefault(_mainHelmet);
	
	var _themes = __webpack_require__("./src/themes/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = {
	  second: {
	    display: 'flex',
	    flex: 1,
	    flexDirection: 'column',
	    justifyContent: 'center',
	    alignItems: 'center',
	    backgroundColor: _themes.colors.white,
	    padding: 45
	  },
	  button: {
	    margin: '20px',
	    cursor: 'pointer',
	    color: _themes.colors.darkBlue,
	    backgroundColor: _themes.colors.white,
	    padding: 20,
	    borderRadius: 10,
	    fontSize: '1.5em'
	  }
	};
	
	var MoonlightingMarketingPage = function MoonlightingMarketingPage(_ref) {
	  var otherProps = _objectWithoutProperties(_ref, []),
	      _ref$keyword = _ref.keyword,
	      keyword = _ref$keyword === undefined ? "doctor" : _ref$keyword;
	
	  var getDetails = function getDetails(pageData) {
	    if (pageData.location && pageData.location.pathname) {
	      var location = pageData.location.pathname.replace('/' + keyword + '_moonlighting_jobs_in/', '').replace('/', '');
	      return location.split(',');
	    }
	    return ['United States', ''];
	  };
	  var details = getDetails(otherProps);
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(_mainHelmet2.default, {
	      title: 'Moonlighting ' + keyword + '  jobs in ' + details[0] + ', ' + details[1] + ' | OnCallogy.com'
	    }),
	    Glamor.createElement(_pageTitle2.default, { title: 'Moonlighting ' + keyword + ' jobs in ' + details[0] + ', ' + details[1] }),
	    Glamor.createElement(
	      'div',
	      { css: _themes.applicationStyles.mainTextContainer, className: 'blog-post' },
	      Glamor.createElement(
	        'p',
	        null,
	        'OnCallogy is partnering with Hospitals, Urgent Cares, Physician Groups, and other facilities across the country. We are actively looking for moonlighting ',
	        keyword,
	        's in ',
	        details[0],
	        ' to join our team.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'The process to become a moonlighting ',
	        keyword,
	        ' in ',
	        details[1],
	        ' is actually suprisingly easy. Since OnCallogy aims to make moonlighting simple, we handle as many of the details of credentialing, calendaring, and malpractice insurance that we are able.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'We invite you to sign up today as a moonlighting ',
	        keyword,
	        ' in ',
	        details[0],
	        ', ',
	        details[1],
	        '.'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'If you happen to know of a facility that could benenfit by more streamlined moonlighting management, drop us a line!'
	      )
	    ),
	    Glamor.createElement(
	      'div',
	      { css: _extends({}, styles.second, { backgroundColor: _themes.colors.darkBlue }) },
	      Glamor.createElement(
	        'div',
	        { css: styles.button, onClick: function onClick() {
	            return (0, _gatsbyLink.navigateTo)('/beta');
	          } },
	        'Join us Today!'
	      )
	    )
	  );
	};
	
	exports.default = MoonlightingMarketingPage;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",[\"/opt/build/repo/node_modules/babel-plugin-module-alias/lib/index.js\",[{\"src\":\"./src/components\",\"expose\":\"components\"},{\"src\":\"./src/components/base\",\"expose\":\"baseComponents\"},{\"src\":\"./src/components/hybrid\",\"expose\":\"hybridComponents\"},{\"src\":\"./src/config\",\"expose\":\"config\"},{\"src\":\"./src/layouts\",\"expose\":\"layouts\"},{\"src\":\"./src/lib\",\"expose\":\"lib\"},{\"src\":\"./src/pages\",\"expose\":\"pages\"},{\"src\":\"./src/stories\",\"expose\":\"stories\"},{\"src\":\"./src/themes\",\"expose\":\"themes\"},{\"src\":\"./src/media\",\"expose\":\"media\"}]],\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/resident_moonlighting_jobs_in.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _doctor_moonlighting_jobs_in = __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",[\"/opt/build/repo/node_modules/babel-plugin-module-alias/lib/index.js\",[{\"src\":\"./src/components\",\"expose\":\"components\"},{\"src\":\"./src/components/base\",\"expose\":\"baseComponents\"},{\"src\":\"./src/components/hybrid\",\"expose\":\"hybridComponents\"},{\"src\":\"./src/config\",\"expose\":\"config\"},{\"src\":\"./src/layouts\",\"expose\":\"layouts\"},{\"src\":\"./src/lib\",\"expose\":\"lib\"},{\"src\":\"./src/pages\",\"expose\":\"pages\"},{\"src\":\"./src/stories\",\"expose\":\"stories\"},{\"src\":\"./src/themes\",\"expose\":\"themes\"},{\"src\":\"./src/media\",\"expose\":\"media\"}]],\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/doctor_moonlighting_jobs_in.js");
	
	var _doctor_moonlighting_jobs_in2 = _interopRequireDefault(_doctor_moonlighting_jobs_in);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return Glamor.createElement(_doctor_moonlighting_jobs_in2.default, _extends({}, props, { keyword: "resident" }));
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resident-moonlighting-jobs-in-js-06b8dddf0fe4844fe2f2.js